export default {
  methods: {
    // 检查用户是否登录
    checkLogin() {
      const token = localStorage.getItem("token");
      return token;
    },

    // 保存当前页面路径并跳转到登录页
    redirectToLogin(showToast = true, path = this.$route.fullPath) {
      if (showToast) {
        this.$toast(this.$t("请先登录"), {
          type: "top",
          timeout: 1000,
          closeOnClick: false,
        });
      }

      localStorage.setItem("redirectUrl", path);
      // 跳转到登录页
      this.$router.push("/login");
    },

    // 检查登录状态，未登录则跳转登录页
    checkLoginAndRedirect(showToast = true, path = this.$route.fullPath) {
      if (!this.checkLogin()) {
        this.redirectToLogin(showToast, path);
        return false;
      }
      return true;
    },
  },
};
